import amplitude from 'amplitude-js';

import { HOUR_IN_MINUTES, isDevelopment, isProduction } from 'consts';

import type { RemoteLevel, TimeZoneSelectOption } from 'types';

const AMPLITUDE_KEY = process.env.REACT_APP_AMPLITUDE_KEY;

class AmplitudeService {
  constructor() {
    this.init();
  }

  client = amplitude.getInstance();
  isRegistered = false;

  init() {
    AMPLITUDE_KEY && amplitude.getInstance().init(AMPLITUDE_KEY);
    this.isRegistered = !!AMPLITUDE_KEY;
  }

  logEvent(
    event: string,
    data?: unknown,
    callback?: amplitude.Callback | undefined,
    errorCallback?: amplitude.Callback | undefined,
    outOfSession?: boolean | undefined
  ) {
    if (this.isRegistered && (isProduction || isDevelopment)) {
      this.client.logEvent(event, data, callback, errorCallback, outOfSession);
    }
  }

  logCostCalculatorClick(country: string) {
    this.logEvent('timezone_crossover_calculator_cost_click', {
      'Country Name': country,
    });
  }

  logHiringGuidesClick(country: string) {
    this.logEvent('timezone_crossover_calculator_hiring_guides_click', {
      'Country Name': country,
    });
  }

  logFormSubmission(
    selectedTimeZone: TimeZoneSelectOption,
    remoteLevel: RemoteLevel
  ) {
    this.logEvent('timezone_crossover_calculator_submit', {
      managersTimeZone: selectedTimeZone.id,
      remoteWorkLevelNumber: remoteLevel.level,
      remoteWorkLevelName: remoteLevel.name,
      isRemoteWorkLevelCustom: remoteLevel.isCustom,
      remoteWorkLevelOverlap: remoteLevel.allowedOverlap / HOUR_IN_MINUTES,
      remoteWorkLevelOverlapUnit: 'hour',
      remoteWorkLevelWordDayStart:
        remoteLevel.workingDayStartAmPm.hours +
        remoteLevel.workingDayStartAmPm.ampm,
      remoteWorkLevelWordDayEnd:
        remoteLevel.workingDayEndAmPm.hours +
        remoteLevel.workingDayEndAmPm.ampm,
    });
  }
}

export const amplitudeService = new AmplitudeService();
